import { FC } from 'react';
import { Box, Divider } from '@chakra-ui/react';
import { TransferPowerForm } from './TransferPowerForm';
import { ExtendedRewardProgram, TemplateName } from 'types';
import { RenounceOwnershipForm } from './RenounceOwnershipForm';
import { RescueERC20Form } from './RescueERC20Form';
import { PowerSwitchStatus } from 'api/blockchain/rewardProgram';
import { mapTemplateNameToRewardpoolAbi } from 'utils/aludelMappings';

type Props = {
  program: ExtendedRewardProgram;
  programState?: PowerSwitchStatus;
};

export const PowerSwitchFormWrapper: FC<Props> = ({
  program,
  programState
}) => {
  const rewardPoolAbi =
    mapTemplateNameToRewardpoolAbi[
      program.rewardProgram.templateName as TemplateName
    ];
  return (
    <>
      <Box p={4}>
        <RescueERC20Form
          program={program}
          programState={programState}
          rewardPoolAbi={rewardPoolAbi}
        />
      </Box>
      <Divider my={4} />
      <Box p={4}>
        <TransferPowerForm
          powerSwitchAddress={program.rewardProgram.powerSwitchAddress}
          aludelAddress={program.rewardProgramAddress}
          aludelAbi={program.rewardProgram.abi}
        />
      </Box>
      <Divider my={4} />
      <Box p={4}>
        <RenounceOwnershipForm
          contractAddress={program.rewardProgram.powerSwitchAddress}
          aludelAddress={program.rewardProgramAddress}
          aludelAbi={program.rewardProgram.abi}
        />
      </Box>
    </>
  );
};
